import { render, staticRenderFns } from "./AudioRecorder.vue?vue&type=template&id=4701dd08&scoped=true&"
import script from "./AudioRecorder.vue?vue&type=script&lang=js&"
export * from "./AudioRecorder.vue?vue&type=script&lang=js&"
import style0 from "./AudioRecorder.vue?vue&type=style&index=0&id=4701dd08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701dd08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
